// Изменилось ли значение с прошлой отрисовки.
//
// Правило 11 `ПРАВИЛА.md` описывает поведение продукта во времени числами: 0 мс — каркас и
// данные прошлой сессии, **300 мс — подмена свежими с однократной подсветкой изменившихся**,
// 1 с — скелет только под тем, чего в кэше не было. Первое и третье в кабинете были сделаны с
// самого начала, второе — нет: свежее число молча вставало на место старого.
//
// Почему это не украшение. Финансовый директор держит экран открытым и разговаривает по
// телефону. Пока он говорит, приходит подтверждение чека, и остаток человека меняется. Без
// подсветки он этого не замечает вовсе: цифра на месте, экран тот же. С подсветкой он видит,
// ЧТО именно поехало, и это ровно тот случай, ради которого правило и написано.
//
// Первая отрисовка подсветкой не считается: иначе при каждом входе в раздел вспыхивал бы весь
// экран, и вспышка перестала бы что-либо означать.

import { useEffect, useRef, useState } from 'react';

/** Длительность подсветки. Совпадает с длительностью самой анимации в настройке оформления. */
const ЖИВЁТ_МС = 1200;

/**
 * `true` — значение только что сменилось. Гаснет само.
 *
 * Сравнение по значению, а не по ссылке: на вход приходит уже отформатированная строка
 * («13 311 851,00»), и именно её видит человек. Сравнивать сырое число было бы точнее для
 * машины и хуже для дела: пересчёт, изменивший копейки ниже показанного знака, вспышкой не
 * является — на экране ничего не изменилось.
 */
export function useСвежесть(значение: unknown): boolean {
  const прошлое = useRef<unknown>(значение);
  const [свежее, setСвежее] = useState(false);

  useEffect(() => {
    if (Object.is(прошлое.current, значение)) {
      return;
    }
    прошлое.current = значение;
    setСвежее(true);
    const таймер = window.setTimeout(() => setСвежее(false), ЖИВЁТ_МС);
    return () => window.clearTimeout(таймер);
  }, [значение]);

  return свежее;
}
